import { render, staticRenderFns } from "./RaitingSummary.vue?vue&type=template&id=5c82d148&"
import script from "./RaitingSummary.vue?vue&type=script&lang=js&"
export * from "./RaitingSummary.vue?vue&type=script&lang=js&"
import style0 from "./RaitingSummary.vue?vue&type=style&index=0&id=5c82d148&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports